import * as React from "react";
type Props = {
  className?: string,
};
function SvgHome({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-home"
      className={className}
    >
      <path
        d="M21 11.05L12 3L3 11.05H6V19.05C6 19.3152 6.10536 19.5696 6.29289 19.7571C6.48043 19.9446 6.73478 20.05 7 20.05H9.63V14.33H14.56V20H17C17.2652 20 17.5196 19.8946 17.7071 19.7071C17.8946 19.5196 18 19.2652 18 19V11L21 11.05Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgHome;
